var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plots",
    attrs: {
      "id": "million-bit-plots"
    }
  }, [(_vm.canClaimRewards && _vm.appData().connectedAccount.address) ? _c('div', {
    staticClass: "rewards-section mb-5"
  }, [_c('h2', {
    staticClass: "mb-3 honk-text"
  }, [_vm._v("Rewards")]), _vm._v(" "), _c('div', {
    staticClass: "rewards-card"
  }, [(_vm.rewardsLoading) ? _c('div', {
    staticClass: "loading-container rewards-loading"
  }, [_c('div', {
    staticClass: "loading-spinner light"
  }), _vm._v(" "), _c('p', {
    staticClass: "loading-text light"
  }, [_vm._v("Checking rewards...")])]) : _c('div', [_c('div', {
    staticClass: "rewards-amount"
  }, [_c('h3', {
    staticClass: "mb-2"
  }, [_vm._v("Available to Claim")]), _vm._v(" "), _c('div', {
    staticClass: "eth-amount"
  }, [_c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.formattedRewards))]), _vm._v(" "), _c('span', {
    staticClass: "currency"
  }, [_vm._v("ETH")])])]), _vm._v(" "), (_vm.hasClaimableRewards) ? _c('button', {
    staticClass: "btn btn-success btn-lg btn-block claim-button",
    attrs: {
      "disabled": _vm.isClaimingRewards
    },
    on: {
      "click": _vm.claimRewards
    }
  }, [(!_vm.isClaimingRewards) ? _c('span', [_vm._v("💰 Claim Rewards")]) : _c('span', [_c('div', {
    staticClass: "loader-inline"
  }), _vm._v("\n            Claiming...\n          ")])]) : _c('p', {
    staticClass: "text-center text-muted mt-3"
  }, [_vm._v("\n          No rewards available to claim yet\n        ")])])])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "mb-4 honk-text"
  }, [_vm._v("My Plots")]), _vm._v(" "), (!_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("Connect your wallet to view your plots")]) : _vm._e(), _vm._v(" "), (_vm.nfts.length > 0) ? _c('div', _vm._l((_vm.nfts), function(nft, index) {
    return _c('div', {
      key: nft.tokenId,
      staticClass: "nft-card"
    }, [_c('img', {
      ref: 'cardImage-' + index,
      refInFor: true,
      staticClass: "plot-nft",
      attrs: {
        "src": nft.image,
        "alt": "NFT Image"
      }
    }), _vm._v(" "), _c('canvas', {
      ref: 'canvas-' + index,
      refInFor: true,
      attrs: {
        "width": nft.width,
        "height": nft.height
      }
    }), _vm._v(" "), _c('p', [_c('input', {
      ref: 'fileInput-' + index,
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "ref": "fileInputs",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, index, nft)
        }
      }
    })]), (nft.showForm) ? _c('div', {}, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nft.link),
        expression: "nft.link"
      }],
      staticClass: "form-control form-control-md mb-2",
      attrs: {
        "type": "text",
        "placeholder": "Enter the URL of the new image"
      },
      domProps: {
        "value": (nft.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nft, "link", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-warning btn-block mb-4",
      attrs: {
        "disabled": nft.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.submitNewImage(index, nft)
        }
      }
    }, [(!nft.isLoading) ? _c('span', [_vm._v("SAVE for "), _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.repaintPriceEth)
      }
    }), _vm._v(" eth")]) : _c('span', {
      staticClass: "saving-state"
    }, [_c('span', {
      staticClass: "loading-spinner-small"
    }), _vm._v(" Saving...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn-group btn-block"
    }, [_c('a', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "href": 'https://magiceden.us/item-details/base/' + _vm.contractAddress + '/' + nft.tokenId,
        "target": "_blank"
      }
    }, [_vm._v("Marketplace")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "href": "#",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.repaint(index, nft)
        }
      }
    }, [_vm._v("Repaint")])]), _vm._v(" "), _c('ul', {
      staticClass: "p-0"
    }, _vm._l((nft.attributes), function(value, key) {
      return (value.trait_type !== 'X1' && value.trait_type !== 'Y1' && value.trait_type !== 'X2' && value.trait_type !== 'Y2') ? _c('li', {
        key: key
      }, [_c('strong', [_vm._v(_vm._s(value.trait_type) + ":")]), _vm._v(" " + _vm._s(value.value) + "\n                  ")]) : _vm._e()
    }), 0), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr')])
  }), 0) : _c('div', [_c('div', [(!_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("Connect your wallet to see your plot NFTs here. Then you can repaint your pixels 👩‍🎨")]) : _c('div', [(_vm.nftsLoading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('div', {
    staticClass: "loading-spinner"
  }), _vm._v(" "), _c('p', {
    staticClass: "loading-text"
  }, [_vm._v("Loading your plots...")])]) : _c('div', [(_vm.nftsLoadError) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("Failed to load plots. Please try again.")]) : _c('p', [_vm._v("No plots found.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.nftsLoading
    },
    on: {
      "click": _vm.getNFTs
    }
  }, [(!_vm.nftsLoading) ? _c('span', [(_vm.nftsLoadError) ? _c('span', [_vm._v("🔄 Retry")]) : _c('span', [_vm._v("🔄 Refresh")])]) : _c('span', [_vm._v("Loading...")])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-repaint-success",
      "title": "You're a part of onchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Your repainted plot has been submitted. "), (_vm.trxHashSuccess) ? _c('a', {
    attrs: {
      "href": 'https://basescan.org/tx/' + _vm.trxHashSuccess,
      "target": "_blank"
    }
  }, [_vm._v("View transaction")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n      Please allow a few minutes for the transaction to be confirmed.\n    ")])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-533387e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Plots.vue
// module id = TAa6
// module chunks = 2